import { render, staticRenderFns } from "./ProductParamList.vue?vue&type=template&id=b8b94016&scoped=true"
import script from "./ProductParamList.vue?vue&type=script&lang=js"
export * from "./ProductParamList.vue?vue&type=script&lang=js"
import style0 from "./ProductParamList.vue?vue&type=style&index=0&id=b8b94016&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b94016",
  null
  
)

export default component.exports